import * as XLSX from 'xlsx';

export interface CostBudgetCategory {
  category: string;
  budget: number;
  actual: number;
  committed: number | null;
  remaining: number;
  percentUsed: number;
  status: string;
}

/**
 * Export cost budget data to Excel
 */
export function exportCostBudgetToExcel(
  categories: CostBudgetCategory[],
  projectName?: string
): void {
  // Transform data for export
  const exportData = categories.map(cat => ({
    Category: cat.category,
    'Budget (£)': cat.budget,
    'Actual (£)': cat.actual,
    'Committed (£)': cat.committed !== null ? cat.committed : '—',
    'Remaining (£)': cat.remaining,
    '% Used': `${cat.percentUsed.toFixed(1)}%`,
    Status: cat.status,
  }));

  // Create workbook and worksheet
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(exportData);

  // Set column widths
  ws['!cols'] = [
    { wch: 25 }, // Category
    { wch: 15 }, // Budget
    { wch: 15 }, // Actual
    { wch: 15 }, // Committed
    { wch: 15 }, // Remaining
    { wch: 12 }, // % Used
    { wch: 15 }, // Status
  ];

  // Add worksheet to workbook
  XLSX.utils.book_append_sheet(wb, ws, 'Cost Budget');

  // Generate file and trigger download
  const fileName = projectName 
    ? `${projectName}_cost_budget_${new Date().toISOString().split('T')[0]}.xlsx`
    : `cost_budget_export_${new Date().toISOString().split('T')[0]}.xlsx`;
  
  XLSX.writeFile(wb, fileName);
}
